import { Link } from 'react-router';

import { ACTIONS } from '../copy';
import { AREA_LABEL, signOut, type Area } from '../session';
import { AREA_HOME } from '../routes/paths';

/**
 * You are signed in, but this is not your half of the product.
 *
 * Says which area was asked for and which one the account belongs to, because
 * "acesso negado" on its own leaves a person unable to tell whether they used
 * the wrong link or the wrong account -- and those have different fixes. Both
 * fixes are offered.
 */
export function AccessDeniedPage({
  requestedArea,
  principalArea,
}: {
  requestedArea: Area;
  principalArea: Area;
}) {
  return (
    <div className="page page--centred">
      <div className="notice" role="alert">
        <h1 className="notice__title">Esta área não é sua</h1>
        <p className="notice__body">
          Você tentou abrir o <strong>{AREA_LABEL[requestedArea]}</strong>, mas sua conta pertence
          ao <strong>{AREA_LABEL[principalArea]}</strong>. Se você precisa desse acesso, fale com
          quem administra sua conta.
        </p>
        <div className="notice__actions">
          <Link className="button button--primary" to={AREA_HOME[principalArea]}>
            {ACTIONS.goToMyArea}
          </Link>
          <button type="button" className="button button--ghost" onClick={signOut}>
            Entrar com outra conta
          </button>
        </div>
      </div>
    </div>
  );
}
